// extracted by mini-css-extract-plugin
export var grayCircle = "_cr-0";
export var renderAfterShippingOptionWidgetPreviewSelected = "_cr-1";
export var selectedCircle = "_cr-2";
export var shippingOptionImage = "_cr-3";
export var shippingOptionWidgetPreview = "_cr-4";